import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a3e1267"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation-mobile-wrapper" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { id: "mobile-navigation-bar" }


  import HeaderMenu from "./HeaderMenu.vue"; 
  import HeaderTherapist from "./HeaderTherapist.vue";
  import NavigationBar from "./NavigationBar.vue";

  
  const __default__ = {
    name: 'NavigationMobile',
    inheritAttrs: false,
    customOptions: {}
  }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {expanded: Boolean, menus: Boolean},
  setup(__props) {

const props = __props;


   

  const openModal = async () => {
    const el: any = document.getElementById('navigation-mobile')
    el.classList.add('openModal')
  }

  const closeModal = async () => {
    const el: any = document.getElementById('navigation-mobile')
    el.classList.remove('openModal')
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "navigation-mobile",
    class: _normalizeClass({open: props.expanded })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(HeaderMenu, {
            onOpenModalEmit: _cache[0] || (_cache[0] = ($event: any) => (openModal())),
            onOpenHelpEmit: _cache[1] || (_cache[1] = ($event: any) => (openModal())),
            onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (closeModal()))
          }),
          _createVNode(HeaderTherapist),
          _createVNode(NavigationBar)
        ])
      ])
    ])
  ], 2))
}
}

})